import { Theme, Tooltip, withStyles } from "@material-ui/core";
import React from "react";

const TooltipControlled = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: theme.palette.warning.light,
    fontSize: theme.typography.pxToRem(12),
    "& .MuiTooltip-arrow::before": {
      backgroundColor: theme.palette.warning.light,
    },
  },
}))(Tooltip);

export default TooltipControlled;
